function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _temp;

var _require = require('@uppy/core'),
    UIPlugin = _require.UIPlugin;

var toArray = require('@uppy/utils/lib/toArray');

var isDragDropSupported = require('@uppy/utils/lib/isDragDropSupported');

var getDroppedFiles = require('@uppy/utils/lib/getDroppedFiles');

var _require2 = require('preact'),
    h = _require2.h;

var locale = require('./locale.js');
/**
 * Drag & Drop plugin
 *
 */


module.exports = (_temp = _class = /*#__PURE__*/function (_UIPlugin) {
  _inherits(DragDrop, _UIPlugin);

  var _super = _createSuper(DragDrop);

  // eslint-disable-next-line global-require
  function DragDrop(uppy, opts) {
    var _this;

    _classCallCheck(this, DragDrop);

    _this = _super.call(this, uppy, opts);

    _this.handleDrop = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var _this$opts$onDrop, _this$opts, logDropError, files;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();
                event.stopPropagation();
                clearTimeout(_this.removeDragOverClassTimeout); // Remove dragover class

                _this.setPluginState({
                  isDraggingOver: false
                });

                logDropError = function logDropError(error) {
                  _this.uppy.log(error, 'error');
                }; // Add all dropped files


                _context.next = 7;
                return getDroppedFiles(event.dataTransfer, {
                  logDropError: logDropError
                });

              case 7:
                files = _context.sent;

                if (files.length > 0) {
                  _this.uppy.log('[DragDrop] Files dropped');

                  _this.addFiles(files);
                }

                (_this$opts$onDrop = (_this$opts = _this.opts).onDrop) == null ? void 0 : _this$opts$onDrop.call(_this$opts, event);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.type = 'acquirer';
    _this.id = _this.opts.id || 'DragDrop';
    _this.title = 'Drag & Drop';
    _this.defaultLocale = locale; // Default options

    var defaultOpts = {
      target: null,
      inputName: 'files[]',
      width: '100%',
      height: '100%',
      note: null
    }; // Merge default options with the ones set by user

    _this.opts = _objectSpread(_objectSpread({}, defaultOpts), opts);

    _this.i18nInit(); // Check for browser dragDrop support


    _this.isDragDropSupported = isDragDropSupported();
    _this.removeDragOverClassTimeout = null; // Bind `this` to class methods

    _this.onInputChange = _this.onInputChange.bind(_assertThisInitialized(_this));
    _this.handleDragOver = _this.handleDragOver.bind(_assertThisInitialized(_this));
    _this.handleDragLeave = _this.handleDragLeave.bind(_assertThisInitialized(_this));
    _this.handleDrop = _this.handleDrop.bind(_assertThisInitialized(_this));
    _this.addFiles = _this.addFiles.bind(_assertThisInitialized(_this));
    _this.render = _this.render.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DragDrop, [{
    key: "addFiles",
    value: function addFiles(files) {
      var _this2 = this;

      var descriptors = files.map(function (file) {
        return {
          source: _this2.id,
          name: file.name,
          type: file.type,
          data: file,
          meta: {
            // path of the file relative to the ancestor directory the user selected.
            // e.g. 'docs/Old Prague/airbnb.pdf'
            relativePath: file.relativePath || null
          }
        };
      });

      try {
        this.uppy.addFiles(descriptors);
      } catch (err) {
        this.uppy.log(err);
      }
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(event) {
      var files = toArray(event.target.files);

      if (files.length > 0) {
        this.uppy.log('[DragDrop] Files selected through input');
        this.addFiles(files);
      } // We clear the input after a file is selected, because otherwise
      // change event is not fired in Chrome and Safari when a file
      // with the same name is selected.
      // ___Why not use value="" on <input/> instead?
      //    Because if we use that method of clearing the input,
      //    Chrome will not trigger change if we drop the same file twice (Issue #768).
      // eslint-disable-next-line no-param-reassign


      event.target.value = null;
    }
  }, {
    key: "handleDragOver",
    value: function handleDragOver(event) {
      var _this$opts$onDragOver, _this$opts2;

      event.preventDefault();
      event.stopPropagation(); // Check if the "type" of the datatransfer object includes files. If not, deny drop.

      var types = event.dataTransfer.types;
      var hasFiles = types.some(function (type) {
        return type === 'Files';
      });

      var _this$uppy$getState = this.uppy.getState(),
          allowNewUpload = _this$uppy$getState.allowNewUpload;

      if (!hasFiles || !allowNewUpload) {
        event.dataTransfer.dropEffect = 'none';
        clearTimeout(this.removeDragOverClassTimeout);
        return;
      } // Add a small (+) icon on drop
      // (and prevent browsers from interpreting this as files being _moved_ into the browser
      // https://github.com/transloadit/uppy/issues/1978)
      //
      // eslint-disable-next-line no-param-reassign


      event.dataTransfer.dropEffect = 'copy';
      clearTimeout(this.removeDragOverClassTimeout);
      this.setPluginState({
        isDraggingOver: true
      });
      (_this$opts$onDragOver = (_this$opts2 = this.opts).onDragOver) == null ? void 0 : _this$opts$onDragOver.call(_this$opts2, event);
    }
  }, {
    key: "handleDragLeave",
    value: function handleDragLeave(event) {
      var _this3 = this;

      var _this$opts$onDragLeav, _this$opts3;

      event.preventDefault();
      event.stopPropagation();
      clearTimeout(this.removeDragOverClassTimeout); // Timeout against flickering, this solution is taken from drag-drop library.
      // Solution with 'pointer-events: none' didn't work across browsers.

      this.removeDragOverClassTimeout = setTimeout(function () {
        _this3.setPluginState({
          isDraggingOver: false
        });
      }, 50);
      (_this$opts$onDragLeav = (_this$opts3 = this.opts).onDragLeave) == null ? void 0 : _this$opts$onDragLeav.call(_this$opts3, event);
    }
  }, {
    key: "renderHiddenFileInput",
    value: function renderHiddenFileInput() {
      var _this4 = this;

      var restrictions = this.uppy.opts.restrictions;
      return h("input", {
        className: "uppy-DragDrop-input",
        type: "file",
        hidden: true,
        ref: function ref(_ref2) {
          _this4.fileInputRef = _ref2;
        },
        name: this.opts.inputName,
        multiple: restrictions.maxNumberOfFiles !== 1,
        accept: restrictions.allowedFileTypes,
        onChange: this.onInputChange
      });
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      return h("div", {
        className: "uppy-DragDrop-label"
      }, this.i18nArray('dropHereOr', {
        browse: h("span", {
          className: "uppy-DragDrop-browse"
        }, this.i18n('browse'))
      }));
    }
  }, {
    key: "renderNote",
    value: function renderNote() {
      return h("span", {
        className: "uppy-DragDrop-note"
      }, this.opts.note);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var dragDropClass = "uppy-Root\n      uppy-u-reset\n      uppy-DragDrop-container\n      ".concat(this.isDragDropSupported ? 'uppy-DragDrop--isDragDropSupported' : '', "\n      ").concat(this.getPluginState().isDraggingOver ? 'uppy-DragDrop--isDraggingOver' : '', "\n    ");
      var dragDropStyle = {
        width: this.opts.width,
        height: this.opts.height
      };
      return h("button", {
        type: "button",
        className: dragDropClass,
        style: dragDropStyle,
        onClick: function onClick() {
          return _this5.fileInputRef.click();
        },
        onDragOver: this.handleDragOver,
        onDragLeave: this.handleDragLeave,
        onDrop: this.handleDrop
      }, this.renderHiddenFileInput(), h("div", {
        className: "uppy-DragDrop-inner"
      }, DragDrop.renderArrowSvg(), this.renderLabel(), this.renderNote()));
    }
  }, {
    key: "install",
    value: function install() {
      var target = this.opts.target;
      this.setPluginState({
        isDraggingOver: false
      });

      if (target) {
        this.mount(target, this);
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.unmount();
    }
  }], [{
    key: "renderArrowSvg",
    value: function renderArrowSvg() {
      return h("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon uppy-DragDrop-arrow",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
      }, h("path", {
        d: "M11 10V0H5v10H2l6 6 6-6h-3zm0 0",
        fillRule: "evenodd"
      }));
    }
  }]);

  return DragDrop;
}(UIPlugin), _class.VERSION = "2.0.6", _temp);